export class SchoolBasicInformation {
         schoolId: number;
         arabicName: string;
         englishName: string;
         academicProgramId: number;
         academicProgramIds: number[] = [];
         userTypesIds:number[]=[];
       }
